module.exports = __webpack_public_path__ + "img/vertical_3_6_8017.97460905.png";